var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "text-body-2 text-secondary--text text-center" },
    [
      _vm._v(
        "\n  " +
          _vm._s(_setup.t("Нажимая", _setup.options)) +
          "\n  «" +
          _vm._s(
            _setup.t(
              _vm.isButtonSendVisible ? "Отправить" : "Подтвердить",
              _setup.options
            )
          ) +
          "»,\n  " +
          _vm._s(_setup.t("соглашаюсь с", _setup.options)) +
          "\n  "
      ),
      _c(
        "a",
        {
          staticClass: "text-decoration-none primary--text d-inline",
          attrs: { href: "/info/privacy-policy/", target: "_blank" },
        },
        [
          _vm._v(
            _vm._s(
              _setup.t(
                "политикой обработки персональных данных",
                _setup.options
              )
            )
          ),
        ]
      ),
      _vm._v("\n  " + _vm._s(_setup.t("и принимаю", _setup.options)) + "\n  "),
      _c(
        "a",
        {
          staticClass: "text-decoration-none primary--text d-inline",
          attrs: { href: "/info/terms-of-use/", target: "_blank" },
        },
        [
          _vm._v(
            _vm._s(_setup.t("пользовательское соглашение", _setup.options))
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }